import Backbone from 'backbone';

export default Backbone.Model.extend({
    defaults: {
        asana_project_id    : '',
        asana_project_name  : '',
        asana_assignee      : '',
        auto_resolve        : false,
        is_auto             : false,
        feedback_type       : '',
        is_disabled         : false
    },

    isConnected: function() {
        return this.get('asana_project_id') ? true : false;
    }
});